import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      //首页
      path: "/home",
      component: resolve => require(["@/views/home"], resolve),
      children: [
        {
          path: '/energyCenter',
          name: '用能中心',
          component: resolve => require(["@/views/energyCenter/index"], resolve),
          children: [
            {
              //电量管理
              path: "/electricQuantityManage",
              name: "electricQuantityManage",
              component: resolve => require(["@/views/energyCenter/electricQuantityManage"], resolve),
            },
            {
              //电量管理
              path: "/classify",
              name: "classify",
              component: resolve => require(["@/views/energyCenter/classify"], resolve),
            },
            {
              //电费管理
              path: "/electricityManage",
              name: "electricityManage",
              component: resolve => require(["@/views/energyCenter/electricityManage"], resolve),
            },
            {
              //自助抄表-单日
              path: "/automaticLogging",
              name: "automaticLogging",
              component: resolve => require(["@/views/energyCenter/automaticLogging"], resolve),
            },
            {
              //自助抄表-区间
              path: "/automaticLoggingRange",
              name: "automaticLoggingRange",
              component: resolve => require(["@/views/energyCenter/automaticLoggingRange"], resolve),
            },
            {
              //用能分析
              path: "/energyAnalysis",
              name: "energyAnalysis",
              component: resolve => require(["@/views/energyCenter/energyAnalysis"], resolve),
            },
            {
              //电价查询
              path: "/priceQuery",
              name: "/priceQuery",
              component: resolve => require(["@/views/energyCenter/priceQuery"], resolve),
            },
          ]
        },
        {
          path: '/monitorCenter',
          name: '监测中心',
          component: resolve => require(["@/views/monitorCenter/index"], resolve),
          children: [
            {
              //负荷监测
              path: "/loadMonitoring",
              name: "loadMonitoring",
              component: resolve => require(["@/views/monitorCenter/loadMonitoring"], resolve),
            },
            {
              //能耗管理
              path: "/energyConsumptionManage",
              name: "energyConsumptionManage",
              component: resolve => require(["@/views/monitorCenter/energyConsumptionManage"], resolve),
            },
            {
              //告警管理
              path: "/alarmManage",
              name: "alarmManage",
              component: resolve => require(["@/views/monitorCenter/alarmManage"], resolve),
            },
            {
              //事件分析
              path: "eventStudy",
              name: "eventStudy",
              component: resolve => require(["@/views/monitorCenter/eventStudy"], resolve),
            },
            {
              //事件处理
              path: "eventHandling",
              name: "eventHandling",
              component: resolve => require(["@/views/monitorCenter/eventHandling"], resolve),
            },
          ]
        },
        {
          path: '/roomCenter',
          name: '客房中心',
          component: resolve => require(["@/views/roomCenter/index"], resolve),
          children: [
            {
              //房态分析
              path: "/roomStatusAnalysis",
              name: "roomStatusAnalysis",
              component: resolve => require(["@/views/roomCenter/roomStatusAnalysis"], resolve),
            },
            {
              //优化排房
              path: "/optimizerowHouses",
              name: "optimizerowHouses",
              component: resolve => require(["@/views/roomCenter/optimizerowHouses"], resolve),
            },
            {
              //客服分析
              path: "/serviceAnalysis",
              name: "serviceAnalysis",
              component: resolve => require(["@/views/roomCenter/serviceAnalysis"], resolve),
            },
          ]
        },
        {
          path: '/statementCenter',
          name: '报表中心',
          component: resolve => require(["@/views/statementCenter/index"], resolve),
          children: [
            {
              //综合报表
              path: "/periodicReport",
              name: "periodicReport",
              component: resolve => require(["@/views/statementCenter/periodicReport"], resolve),
            },
            {
              //设备报表
              path: "/equipmentReport",
              name: "equipmentReport",
              component: resolve => require(["@/views/statementCenter/equipmentReport"], resolve),
            },
            {
              //用能分析报告
              path: "/energyAnalysisReport",
              name: "energyAnalysisReport",
              component: resolve => require(["@/views/statementCenter/energyAnalysisReport"], resolve),
            },
            {
              //客房诊断报告
              path: '/energyDiagnosis',
              name: "energyDiagnosis",
              component: resolve => require(["@/views/statementCenter/energyDiagnosis"], resolve),
            },
            {
              //采集数据查询
              path: "/syntheticData",
              name: "syntheticData",
              component: resolve => require(["@/views/statementCenter/syntheticData"], resolve),
            },
          ]
        },
        {
          //系统管理
          path: "/systemManagement",
          name: "systemManagement",
          component: resolve => require(["@/views/systemManagement/index"], resolve),
          children: [
            {
              //关于我们
              path: "/aboutUs",
              name: "aboutUs",
              component: resolve => require(["@/views/systemManagement/aboutUs"], resolve),
            },
            {
              //创建账号
              path: "/createAccount",
              name: "createAccount",
              component: resolve => require(["@/views/systemManagement/createAccount"], resolve),
            },
            {
              //账号管理
              path: "/accountManagement",
              name: "accountManagement",
              component: resolve => require(["@/views/systemManagement/accountManagement"], resolve),
            },
          ]
        },


        // ----------------------------------------------------------




        // {
        //   //监测中心
        //   path: "/monitoringCenter",
        //   name: "monitoringCenter",
        //   component: resolve => require(["@/views/monitoringCenter"], resolve),
        //   children: [
        //     {
        //       //用能监测
        //       path: "/usedMonitor",
        //       name: "usedMonitor",
        //       component: resolve => require(["@/views/monitoringCenter/usedMonitor/index"], resolve),
        //       children: [
        //         {
        //           //用能监测
        //           path: "",
        //           name: "usedMonitors",
        //           component: resolve => require(["@/views/monitoringCenter/usedMonitor/usedMonitor"], resolve),
        //         },
        //         {
        //           //用能监测-用能详情
        //           path: "canUseForDetails/:id",
        //           name: "canUseForDetails",
        //           component: resolve => require(["@/views/monitoringCenter/usedMonitor/canUseForDetails"], resolve),
        //         },
        //       ]
        //     },
        //     {
        //       //综合能耗
        //       path: "/comprehensive",
        //       name: "comprehensive",
        //       component: resolve => require(["@/views/monitoringCenter/comprehensive"], resolve),
        //     },
        //     {
        //       //单客能耗
        //       path: "/singleGuest",
        //       name: "singleGuest",
        //       component: resolve => require(["@/views/monitoringCenter/singleGuest"], resolve),
        //     },
        //     {
        //       //能耗诊断
        //       path: "/energyDiagnosis",
        //       name: "energyDiagnosis",
        //       component: resolve => require(["@/views/monitoringCenter/energyDiagnosis"], resolve),
        //     },
        //     {
        //       //自动抄表
        //       path: "/automaticLogging",
        //       name: "automaticLogging",
        //       component: resolve => require(["@/views/monitoringCenter/automaticLogging"], resolve),
        //     }
        //   ]
        // },
        // {
        //   //告警中心
        //   path: "/alarmCenter",
        //   name: "alarmCenter",
        //   component: resolve => require(["@/views/alarmCenter"], resolve),
        //   children: [
        //     {
        //       //异常事件
        //       path: "",
        //       name: "anomalousEvent",
        //       component: resolve => require(["@/views/alarmCenter/anomalousEvent"], resolve),
        //     },
        //     {
        //       //事件分析
        //       path: "eventStudy/:id",
        //       name: "eventStudy",
        //       component: resolve => require(["@/views/alarmCenter/eventStudy"], resolve),
        //     },
        //     {
        //       //事件处理
        //       path: "eventHandling",
        //       name: "eventHandling",
        //       component: resolve => require(["@/views/alarmCenter/eventHandling"], resolve),
        //     },
        //   ]
        // },
        // {
        //   //客房中心
        //   path: "/housekeeping",
        //   name: "housekeeping",
        //   component: resolve => require(['@/views/housekeeping'], resolve),
        //   children: [
        //     {
        //       //绿能客房
        //       path: "/canGreenRooms",
        //       name: "canGreenRooms",
        //       component: resolve => require(["@/views/housekeeping/canGreenRooms"], resolve),
        //     },
        //     {
        //       //优化排房
        //       path: "/optimizerowHouses",
        //       name: "optimizerowHouses",
        //       component: resolve => require(["@/views/housekeeping/optimizerowHouses"], resolve),
        //     },
        //     {
        //       //客房分析
        //       path: "/guestRoomAnalysis",
        //       name: "guestRoomAnalysis",
        //       component: resolve => require(["@/views/housekeeping/guestRoomAnalysis"], resolve),
        //     },
        //   ]
        // },
        // {
        //   //统计分析
        //   path: "/statisticAnalysis",
        //   name: "statisticAnalysis",
        //   component: resolve => require(["@/views/statisticAnalysis"], resolve),
        //   children: [
        //     {
        //       //综合数据
        //       path: "/syntheticData",
        //       name: "syntheticData",
        //       component: resolve => require(["@/views/statisticAnalysis/syntheticData"], resolve),
        //     },
        //     {
        //       //周期性报告
        //       path: "/periodicReport",
        //       name: "periodicReport",
        //       component: resolve => require(["@/views/statisticAnalysis/periodicReport"], resolve),
        //     },
        //   ]
        // },
        // {
        //   //系统管理
        //   path: "/systemManagement",
        //   name: "systemManagement",
        //   component: resolve => require(["@/views/systemManagement"], resolve),
        //   children: [
        //     {
        //       //关于我们
        //       path: "/aboutUs",
        //       name: "aboutUs",
        //       component: resolve => require(["@/views/systemManagement/aboutUs"], resolve),
        //     },
        //     {
        //       //创建账号
        //       path: "/createAccount",
        //       name: "createAccount",
        //       component: resolve => require(["@/views/systemManagement/createAccount"], resolve),
        //     },
        //     {
        //       //账号管理
        //       path: "/accountManagement",
        //       name: "accountManagement",
        //       component: resolve => require(["@/views/systemManagement/accountManagement"], resolve),
        //     },
        //   ]
        // },
      ]
    },
    //登录
    {
      path: '/login',
      name: 'login',
      component: resolve => require(["@/views/login"], resolve)
    },
    {path: "*", redirect: "/login"},


    // {
    //   //大屏集团
    //   path: "/group",
    //   name: "group",
    //   component: resolve => require(["@/views/bigScreen/group"], resolve),
    // },
    // {
    //   //大屏集团地图
    //   path: "/map",
    //   name: "map",
    //   component: resolve => require(["@/views/bigScreen/map"], resolve),
    // },
    // {
    //   //大屏酒店
    //   path: "/alone",
    //   name: "alone",
    //   component: resolve => require(["@/views/bigScreen/alone"], resolve),
    // },
    
    // //大屏登录
    // {
    //   path: '/loginBig',
    //   name: 'loginBig',
    //   component: resolve => require(["@/views/loginBig"], resolve)
    // },
    // {path: "*", redirect: "/loginBig"},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js